module.exports = __webpack_public_path__ + "img/behance-cover.6784c4bf.jpg";